import { render, staticRenderFns } from "./EditUserPopup.vue?vue&type=template&id=ef04c620&"
import script from "./EditUserPopup.vue?vue&type=script&lang=ts&"
export * from "./EditUserPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports